import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, confirmPasswordReset } from 'firebase/auth';
import {
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Paper,
  FormControlLabel,
  Checkbox,
  Stack,
} from '@mui/material';

const ForgotPasswordRedirectPage = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const queryParameters = new URLSearchParams(window.location.search);
  const oobCode = queryParameters.get('oobCode');

  const setNewPassword = async () => {
    setError('');
    setSuccess('');

    if (!password || !confirmPassword) {
      setError('Please fill out both password fields.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Password and Confirm Password do not match.');
      return;
    }

    setIsSubmitting(true);

    try {
      if (oobCode) {
        await confirmPasswordReset(getAuth(), oobCode, confirmPassword);
        setSuccess('Your password has been successfully updated. Redirecting to login...');
        setTimeout(() => navigate('/login'), 4000);
      } else {
        setError('Reset link is invalid or missing.');
      }
    } catch (e) {
      if (e.code === 'auth/weak-password') {
        setError('Passwords must contain at least 6 characters.');
      } else {
        setError(e.message || 'Something went wrong. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Set New Password
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Stack spacing={2} component="form" onSubmit={(e) => { e.preventDefault(); setNewPassword(); }}>
          <TextField
            type={showPassword ? 'text' : 'password'}
            label="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isSubmitting}
            required
          />

          <TextField
            type={showPassword ? 'text' : 'password'}
            label="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={isSubmitting}
            required
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={showPassword}
                onChange={() => setShowPassword((prev) => !prev)}
              />
            }
            label="Show Passwords"
          />

          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Updating...' : 'Reset Password'}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ForgotPasswordRedirectPage;
